import { FileWarning } from "lucide-react";
import { DISPOSITION_LABELS, PAYMENT_LABELS, WORKFLOW_LABELS } from "../../lib/finance";

// Workflow (brouillon / soumise) and payment (non payée / partiellement / payée) are two independent axes:
// they never share a badge style, so a "Soumise" expense can still read "Non payée" without ambiguity.

const PAYMENT_STYLES = {
  unpaid: "bg-slate-100 text-slate-700 border-slate-200",
  partially_paid: "bg-amber-50 text-amber-800 border-amber-200",
  paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
};

const base = "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-2xs font-medium whitespace-nowrap";

export function PaymentBadge({ status }) {
  return <span className={`${base} ${PAYMENT_STYLES[status] || PAYMENT_STYLES.unpaid}`} data-testid="payment-badge">{PAYMENT_LABELS[status] || PAYMENT_LABELS.unpaid}</span>;
}

export function WorkflowBadge({ status }) {
  const style = status === "submitted" ? "bg-jamora-50 text-jamora border-jamora-200" : "bg-white text-slate-600 border-slate-300 border-dashed";
  return <span className={`${base} ${style}`} data-testid="workflow-badge">{WORKFLOW_LABELS[status] || status}</span>;
}

export function ReceiptMissingBadge() {
  return (
    <span className={`${base} bg-red-50 text-red-700 border-red-200`} data-testid="receipt-missing-badge">
      <FileWarning size={11} aria-hidden="true" /> Justificatif manquant
    </span>
  );
}

const DISPOSITION_STYLES = {
  a_decider: "bg-white text-slate-600 border-slate-300",
  a_rembourser: "bg-amber-50 text-amber-800 border-amber-200",
  apport: "bg-jamora-50 text-jamora border-jamora-200",
  abandon: "bg-slate-100 text-slate-600 border-slate-200",
};

// The decision recorded on an advance (never shown for Jamora's own payments or on a draft).
export function DispositionBadge({ status }) {
  if (!status) return null;
  return <span className={`${base} ${DISPOSITION_STYLES[status] || DISPOSITION_STYLES.a_decider}`} data-testid="disposition-badge">{DISPOSITION_LABELS[status] || status}</span>;
}
